<template>
  <div class="cabecera-style">
    <div class="card-container">
      <div
        class="card"
        v-for="(car, index) in cars"
        :key="car.id"
        @click="openModal(car.id)"
        :data-car="car.id"
        :style="(index + 1) % 2 === 0 ? evenCardStyle : {}"
      >
        <div class="card-content">
          <h3 class="card-title">
            <span class="card-model">{{ car.name }}</span>
          </h3>
          <img
            :src="car.image"
            :alt="`Imagen del ${car.name}`"
            class="card-img"
          />
          <button class="card-btn" @click.stop="handleButtonClick(car.id)">
            Reserva tu cita
          </button>
        </div>
      </div>
    </div>

    <modal
      v-if="isModalOpen"
      :isOpen="isModalOpen"
      :selectedCar="selectedCar"
      :selectedCarImage="selectedCarImage"
      @close="closeModal"
      @submit="handleReservation"
      @open-client-modal="openClientModal"
    />

    <formularioRegistro
      v-if="isClientModalOpen"
      :isOpen="isClientModalOpen"
      :selectedCarDetails="this.selectedCarDetails"
      @close="closeClientModal"
      @submit="handleClientRegistration"
      @leadGenerated="openModal3"
    />

    <finalModal v-if="isModal3Open" :show="isModal3Open" @close="closeModal3" />
  </div>
</template>

<script>
import modal from "./modal.vue";
import formularioRegistro from "./formularioRegistro";
import * as servicios from "../../servicios";
import finalModal from "./finalModal";

export default {
  props: ["token"],
  components: {
    modal,
    formularioRegistro,
    finalModal,
  },
  data() {
    return {
      evenCardStyle: {
        background: "#e6e7e9",
      },
      isModalOpen: false,
      isClientModalOpen: false,
      selectedCar: null,
      selectedCarImage: "",
      modelosComercial: [],
      isModal3Open: false,
      cars: [
        /*
        { id: 'EV5', name: 'New EV5', image: require('@/assets/images/Imagenes_Kia_Ev5.png') },
        { id: 'EV6', name: 'New EV6', image: require('@/assets/images/Imagenes_Kia_Ev6.png') },
        { id: 'EV9', name: 'New EV9', image: require('@/assets/images/Imagenes_Kia_Ev9.png') },
        { id: 'NUEVO NIRO EV', name: 'New Niro EV', image: require('@/assets/images/Imagenes_Kia_Niro_Ev.png') }
        */
      ],
    };
  },
  methods: {
    openModal(carId) {
      const car = this.cars.find((c) => c.id === carId);
      if (!car) {
        //console.warn(`No se encontró el vehículo con ID: ${carId}`);
        return;
      }

      const modeloFiltrado = this.modelosComercial.find(
        (modelo) => modelo.dt1 === carId
      );
      if (!modeloFiltrado || !modeloFiltrado.dt1) {
        /*
        console.warn(
          `No se encontró un modelo válido con ID: ${carId} o no tiene dt1 definido.`
        );
        */
        return;
      }
      this.selectedCar = car.id;
      this.selectedCarImage = car.image;
      this.isModalOpen = true;
      this.selectedCarDetails = {
        dt1: modeloFiltrado.dt1,
        detallesAdicionales: modeloFiltrado,
      };
    },

    closeModal() {
      this.isModalOpen = false;
    },
    openClientModal() {
      this.isClientModalOpen = true;
    },
    closeClientModal() {
      this.isClientModalOpen = false;
    },
    handleReservation() {
      this.closeModal();
    },
    handleClientRegistration(clientInfo) {
      alert(
        `Cliente registrado: ${clientInfo.firstName1} ${clientInfo.lastName1}`
      );
      this.closeClientModal();
    },
    handleButtonClick(carId) {
      const button = event.target;
      button.classList.add("clicked");
      setTimeout(() => {
        button.classList.remove("clicked");
      }, 300);
      this.openModal(carId);
    },

    consultarModeloComercial() {
      servicios.modeloComercial.modeloComercial().then((response) => {
        const modelosPermitidos = this.getModelosPermitidos();

        const filtrados = response.data.filter((item) =>
          modelosPermitidos.includes((item.dt1 || '').toUpperCase())
        );

        
        filtrados.sort((a, b) => {
          const indexA = modelosPermitidos.indexOf((a.dt1 || '').trim().toUpperCase());
          const indexB = modelosPermitidos.indexOf((b.dt1 || '').trim().toUpperCase());
          return indexA - indexB;
        });

        this.modelosComercial = filtrados;
        this.cars = this.modelosComercial.map((modelo) => ({
          id: modelo.dt1,
          name: modelo.dt1,
          image: `https://formulariosweb.kiaecuador.com.ec${modelo.dt3}`,
        }));
      });
    },
    getModelosPermitidos() {
      return (process.env.VUE_APP_MODELOS_COMERCIALES || '')
        .split(',')
        .map(m => m.trim().toUpperCase());
    },



    openModal3() {
      this.isModal3Open = true;
    },

    closeModal3() {
      this.isModal3Open = false;
    },
  },

  async mounted() {
    await this.consultarModeloComercial();
  },
};
</script>

<style scoped>
.card-container {
  display: flex;
  flex-wrap: wrap;
  padding: 20px;
  justify-content: center;
  width: 80%;
  margin-bottom: 60px;
}

.card {
  width: calc(25% - 20px);
  overflow: hidden;
  text-align: center;
  background: #fff;
  transition: transform 0.3s ease;
  padding-bottom: 2rem;
}

.card:hover {
  transform: translateY(-5px);
}

.card-img {
  width: 90%;
  object-fit: cover;
}

.card-content {
  padding: 10px;
}

.card-title {
  font-size: 18px;
  margin-top: 10px;
  padding-top: 1rem;
  text-align: center;
  line-height: 0.8;
}

.card-btn {
  background-color: #05141f !important;
  color: white;
  padding: 16px 30px; /* Este padding mantiene el tamaño del botón */
  font-size: 14px; /* Solo baja el tamaño del texto */
  border: none;
  cursor: pointer;
  transition: transform 0.2s, opacity 0.3s ease-in-out;
  line-height: 1.2;
}

.card-btn:hover {
  background-color: #0a2a3f !important;
}

.card-btn.clicked {
  transform: scale(1.1);
  opacity: 0.8;
  transition: transform 0.2s ease, opacity 0.3s ease;
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

@media (max-width: 768px) {
  .card {
    width: calc(50% - 20px);
  }
}

@media (max-width: 480px) {
  .card {
    width: 100%;
  }
}

.cabecera-style {
  display: flex;
  justify-content: center;
  background-color: #f6f3ee;
}

.card-subtitle {
  font-size: 18px;
  font-weight: 400;
  display: block;
  color: #05141f;
}

.card-model {
  font-size: 18px;
  display: block;
  color: #05141f;
}
</style>
